module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div class="row">\n    <div class="col-md-10">\n      <h5 class="billnumhed">\n        <a href="#bills/'+
((__t=( bill_id ))==null?'':_.escape(__t))+
'" id="billhed'+
((__t=( bill_id ))==null?'':_.escape(__t))+
'" oncontextmenu="return false"><i class="fa-regular fa-file-lines"></i></i> '+
((__t=( document_type ))==null?'':_.escape(__t))+
' '+
((__t=( number ))==null?'':_.escape(__t))+
': '+
((__t=( title ))==null?'':_.escape(__t))+
'</a>\n      </h5>\n\n      <p>'+
((__t=( description ))==null?'':_.escape(__t))+
'</p>\n      <p><strong>Latest status:</strong> '+
((__t=( status_description ))==null?'':__t)+
' ('+
((__t=( formatStatusDate(status_date) ))==null?'':_.escape(__t))+
')</p>\n    </div>\n    <div class="col-sm-2">\n      ';
 if (passed_over === -1) { 
__p+='\n        <div class="bill-status-box not-passed">\n          Dead bill <br/><i class="fa fa-times red hover tipped" title="This bill did not cross over from one house to the other by the 30th day of the legislative session, known as Crossover Day. By tradition, if a bill or constitutional amendment resolution is not passed out of its chamber of origin by Crossover Day, it becomes inactive until the legislative session resumes next year. However, the substance of the bill can still be amended to a live bill later in this year&#39s session. Local bills and private resolutions are not affected by the Crossover Day deadline."></i>\n        </div>\n      ';
 } else if (vetoed === 1 ) { 
__p+='\n        <div class="bill-status-box not-passed">\n          Vetoed by Governor<br/>\n          <i class="fa fa-times red hover tipped"></i>\n        </div>\n      ';
 } else if (bill_passed === 1) { 
__p+='\n        <div class="bill-status-box passed">\n          Bill passed<br/><i class="fa fa-check green hover tipped" title="This bill has been passed by the legislature. If the Governor signs it, or if he does not veto it within 40 days after the end of the session, it becomes law on the bill\'s effective date, commonly July 1."></i>\n        </div>\n      ';
 } else { 
__p+='\n           <div class="bill-status-box not-passed">\n            Dead bill <br/><i class="fa fa-times red hover tipped" title="This bill was not passed by the Georgia General Assembly during the most recent session."></i>\n          </div>\n      ';
 } 
__p+='\n    </div>\n  </div>';
}
return __p;
};
